export interface ProximityMemoInputs {
  anyoneMoved: boolean
  msSinceLastFullCalc: number
  hasCachedResult: boolean
  memoTtlMs?: number
}

/** True when calculateProximity may return the memoised result instead of recalculating. */
export function canUseProximityMemo({
  anyoneMoved,
  msSinceLastFullCalc,
  hasCachedResult,
  memoTtlMs = 1000,
}: ProximityMemoInputs): boolean {
  return !anyoneMoved && hasCachedResult && msSinceLastFullCalc < memoTtlMs
}
